import script from "./Calendar.vue?vue&type=script&setup=true&lang=ts"
export * from "./Calendar.vue?vue&type=script&setup=true&lang=ts"

import "./Calendar.vue?vue&type=style&index=0&id=3aa24c64&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3aa24c64"]])

export default __exports__